import { DEFAULT_LOCALE, SupportedLocale } from "./locales";

type SupportCopy = {
  title: string;
  intro: string;
  emailLabel: string;
  discordLabel: string;
  feedbackLabel: string;
  discordCta: string;
  feedbackTypeLabel: string;
  feedbackMessageLabel: string;
  feedbackEmailLabel: string;
  feedbackRatingLabel: string;
  feedbackSubmitCta: string;
  feedbackSubmittingCta: string;
  feedbackSuccessMessage: string;
  feedbackErrorMessage: string;
  feedbackTypeOptions: {
    general: string;
    bug: string;
    feature: string;
    other: string;
  };
};

const supportCopy: Record<SupportedLocale, SupportCopy> = {
  en: {
    title: "Support",
    intro: "If you need help or have any questions, feel free to reach out to us.",
    emailLabel: "Email:",
    discordLabel: "Discord:",
    feedbackLabel: "Help us improve our service:",
    discordCta: "Join our Discord",
    feedbackTypeLabel: "Type",
    feedbackMessageLabel: "Suggestions",
    feedbackEmailLabel: "Email (optional)",
    feedbackRatingLabel: "Rating (optional)",
    feedbackSubmitCta: "Submit feedback",
    feedbackSubmittingCta: "Submitting...",
    feedbackSuccessMessage: "Thanks, your feedback has been sent.",
    feedbackErrorMessage: "Could not submit feedback. Please try again.",
    feedbackTypeOptions: {
      general: "General",
      bug: "Bug report",
      feature: "Feature request",
      other: "Other",
    },
  },
  es: {
    title: "Soporte",
    intro: "Si necesitas ayuda o tienes alguna pregunta, ponte en contacto con nosotros.",
    emailLabel: "Email:",
    discordLabel: "Discord:",
    feedbackLabel: "Ayúdanos a mejorar nuestro servicio:",
    discordCta: "Únete a nuestro Discord",
    feedbackTypeLabel: "Tipo",
    feedbackMessageLabel: "Sugerencias",
    feedbackEmailLabel: "Email (opcional)",
    feedbackRatingLabel: "Valoración (opcional)",
    feedbackSubmitCta: "Enviar feedback",
    feedbackSubmittingCta: "Enviando...",
    feedbackSuccessMessage: "Gracias, tu feedback fue enviado.",
    feedbackErrorMessage: "No se pudo enviar el feedback. Inténtalo de nuevo.",
    feedbackTypeOptions: {
      general: "General",
      bug: "Reporte de error",
      feature: "Solicitud de función",
      other: "Otro",
    },
  },
  fr: {
    title: "Support",
    intro: "Si vous avez besoin d'aide ou si vous avez des questions, contactez-nous.",
    emailLabel: "E-mail :",
    discordLabel: "Discord :",
    feedbackLabel: "Aidez-nous à améliorer notre service :",
    discordCta: "Rejoindre notre Discord",
    feedbackTypeLabel: "Type",
    feedbackMessageLabel: "Suggestions",
    feedbackEmailLabel: "E-mail (optionnel)",
    feedbackRatingLabel: "Note (optionnelle)",
    feedbackSubmitCta: "Envoyer le feedback",
    feedbackSubmittingCta: "Envoi...",
    feedbackSuccessMessage: "Merci, votre feedback a été envoyé.",
    feedbackErrorMessage: "Impossible d'envoyer le feedback. Réessayez.",
    feedbackTypeOptions: {
      general: "Général",
      bug: "Signaler un bug",
      feature: "Demande de fonctionnalité",
      other: "Autre",
    },
  },
  de: {
    title: "Support",
    intro: "Wenn du Hilfe brauchst oder Fragen hast, kontaktiere uns gerne.",
    emailLabel: "E-Mail:",
    discordLabel: "Discord:",
    feedbackLabel: "Hilf uns, unseren Service zu verbessern:",
    discordCta: "Tritt unserem Discord bei",
    feedbackTypeLabel: "Typ",
    feedbackMessageLabel: "Vorschläge",
    feedbackEmailLabel: "E-Mail (optional)",
    feedbackRatingLabel: "Bewertung (optional)",
    feedbackSubmitCta: "Feedback senden",
    feedbackSubmittingCta: "Wird gesendet...",
    feedbackSuccessMessage: "Danke, dein Feedback wurde gesendet.",
    feedbackErrorMessage: "Feedback konnte nicht gesendet werden. Bitte erneut versuchen.",
    feedbackTypeOptions: {
      general: "Allgemein",
      bug: "Fehler melden",
      feature: "Feature-Wunsch",
      other: "Sonstiges",
    },
  },
  it: {
    title: "Supporto",
    intro: "Se hai bisogno di aiuto o hai domande, contattaci pure.",
    emailLabel: "Email:",
    discordLabel: "Discord:",
    feedbackLabel: "Aiutaci a migliorare il nostro servizio:",
    discordCta: "Unisciti al nostro Discord",
    feedbackTypeLabel: "Tipo",
    feedbackMessageLabel: "Suggerimenti",
    feedbackEmailLabel: "Email (opzionale)",
    feedbackRatingLabel: "Valutazione (opzionale)",
    feedbackSubmitCta: "Invia feedback",
    feedbackSubmittingCta: "Invio in corso...",
    feedbackSuccessMessage: "Grazie, il tuo feedback è stato inviato.",
    feedbackErrorMessage: "Impossibile inviare il feedback. Riprova.",
    feedbackTypeOptions: {
      general: "Generale",
      bug: "Segnala bug",
      feature: "Richiesta funzionalità",
      other: "Altro",
    },
  },
  pt: {
    title: "Suporte",
    intro: "Se precisar de ajuda ou tiver dúvidas, fale conosco.",
    emailLabel: "Email:",
    discordLabel: "Discord:",
    feedbackLabel: "Ajude a melhorar nosso serviço:",
    discordCta: "Entre no nosso Discord",
    feedbackTypeLabel: "Tipo",
    feedbackMessageLabel: "Sugestoes",
    feedbackEmailLabel: "Email (opcional)",
    feedbackRatingLabel: "Avaliação (opcional)",
    feedbackSubmitCta: "Enviar feedback",
    feedbackSubmittingCta: "Enviando...",
    feedbackSuccessMessage: "Obrigado, seu feedback foi enviado.",
    feedbackErrorMessage: "Não foi possível enviar o feedback. Tente novamente.",
    feedbackTypeOptions: {
      general: "Geral",
      bug: "Relatar bug",
      feature: "Pedido de recurso",
      other: "Outro",
    },
  },
};

export function getSupportCopy(locale: SupportedLocale): SupportCopy {
  return supportCopy[locale] ?? supportCopy[DEFAULT_LOCALE];
}
